import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import JobAgentChangeNotification from "../../../../../model/notification/assignee/job/JobAgentChangeNotification";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: JobAgentChangeNotification;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class NotificationJobAgentChangedItem extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.routeToJob = this.routeToJob.bind(this);
	}

	render() {
		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});
		const jobRefNo = this.props.notification.data.getJobReferenceNumber();
		const from = this.props.notification.displayPreviousAssignee();
		const to = this.props.notification.displayCurrentAssignee();
		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icon-noti-reminder.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						Job {jobRefNo} &middot;
						Agent changed from {from} to {to}
					</div>
					<div className={"notification-content"}>
						{this.props.notification.displayCreatorName()}<br/>
						{this.props.notification.displayDate()}
					</div>
					<span className="notification-link" onClick={this.routeToJob}>View</span>
					<span className="notification-link-separator">|</span>
					{this.renderNotificationActions()}
				</div>
			</div>
		);
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read) {
			return <span className="notification-link"
						 onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>;
		}
		return <span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>;
	}

	/**
	 * Route to Proper job.
	 */
	routeToJob() {
		this.props.history.push(Routes.EditJob(this.props.notification.data.getJobReferenceNumber()));
	}
}

export default withRouter<IComponentProps>(NotificationJobAgentChangedItem);
